// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cgC79","top":"styles_top__2FiPd"};